<template>
  <div class="home">
    
    <!-- netAtmo -->
    <ttbox-netatmo />

    <ttbox-interface :ttInterface="inter" :key="inter.idInterface" v-for="inter in interfaces" ></ttbox-interface>

<!-- A remplacer par un bouton + plus élégant
    <div class="card">
      <div class="card-content">
        <div class="content">
          <a class="button">
            <span class="icon">
              <i class="fas fa-plus-circle"></i>
            </span>
            <span>Nouvelle Interface</span>
          </a>
        </div>
      </div>
    </div>
-->

  </div>
</template>

<script>
import Interface from '../components/Interface'
import NetAtmo from '../components/NetAtmo'

export default {
  name: 'home',
  components: {
    'ttbox-interface': Interface,
    'ttbox-netatmo': NetAtmo
  },
  computed:{
    interfaces() {
      return this.$store.state.interfaces
    }
  }
}
</script>

<style scoped>
.home {
  justify-content: center;
  flex-flow: row wrap;
  display: flex;
  align-content: stretch;
  align-items: stretch;
}

.card {
  width: 300px;
}

@media (max-width: 640px) {
  .card {
    justify-content: center;
    display: flex;
    flex-grow: 1; 
  }
}

</style>
